
<template>
    <LandRedemption></LandRedemption>
</template>

<script>
    import LandRedemption from './components/LandRedemption.vue'

    export default {
        name: 'App',
        components: {
            LandRedemption
        }
    }
</script>

